import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=8dcce1b6&scoped=true"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"
import style0 from "./Docs.vue?vue&type=style&index=0&id=8dcce1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcce1b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
